import axios from 'axios'

var qs = require('qs');
var root = window.API_ROOT


export const getList = (params) => {
  return axios.post(root + '/pay/category/list', qs.stringify(params))
}
//不分页
export const getListNoPage = (params) => {
  return axios.post(root + '/pay/category/getlistnopage', qs.stringify(params))
}
//根据权限获取
export const getListByRight = (params) => {
  return axios.post(root + '/pay/category/getListByRight', qs.stringify(params))
}
//删除行
export const deleteData = (params) => {
  return axios.post(root + '/pay/category/remove', qs.stringify(params))
}

//获取某一行的明细数据
export const getDetail = (params) => {
  return axios.post(root + '/pay/category/detail', qs.stringify(params))
}

//保存某一行的数据
export const saveData = (params, isAdd) => {
  if (!isAdd) {//更新
    return axios.post(root + '/pay/category/update', qs.stringify(params))
  } else {
    //新增
    return axios.post(root + '/pay/category/save', qs.stringify(params))
  }
}

//更新是否启用
export const updateEnabled = (params) => {
  return axios.post(root + '/pay/category/updateenabled', qs.stringify(params))
}
//获取某一行的明细数据
export const getCategoryTree = (params) => {
  return axios.post(root + '/pay/category/tree', qs.stringify(params))
}

//获取默认编码
export const getDefaultCode = (params) => {
  return axios.post(root + '/pay/category/getDefaultCode', qs.stringify(params))
}

//获取收入大类
export const getshourutypes = (params) => {
  return axios.post(root + '/pay/category/getshourutypes', qs.stringify(params))
}

//更新收入大类
export const updateshourutypes = (params) => {
  return axios.post(root + '/pay/category/updateshourutypes', qs.stringify(params))
}



// WEBPACK FOOTER //
// ./src/api/set/Category.js